import * as React from "react";

import { DataExtractor, getExtractor } from "../../utils/dataView";
import {
    SimpleAndFilter,
    SimpleFieldFilter,
    QueryResult,
    DataViewIndex,
} from "../../utils/indexing";
import { FilterTags } from "../filterTags";
import { FilterTypeahead } from "../filterTypeahead";
import type { FilterTypeaheadProps, ExtractorRef } from "../filterTypeahead";

import * as theme from "./theme.css";

class Filter<ITEM> extends React.Component<FilterProps<ITEM>> {
    render() {
        const {
            id,
            queryResult,
            hideTypeahead,
            hideResultCount,
            filter,
            children,
            dataViewIndex,
            extractorRefs,
            onAddFilter,
            onRemoveFilter,
            onResetFilter,
        } = this.props;
        const FilterTypeaheadElt: new (
            props: FilterTypeaheadProps<ITEM>
        ) => React.Component<FilterTypeaheadProps<ITEM>, any> = FilterTypeahead;
        const toDisplayFilter = (
            extractorId: string,
            filter: SimpleFieldFilter
        ) => dataViewIndex.toDisplayFilter(extractorId, filter);
        return (
            <div>
                <div className={theme.topContainer}>
                    {hideTypeahead ? null : (
                        <div className={theme.typeaheadContainer}>
                            <FilterTypeaheadElt
                                id={id}
                                queryResult={queryResult}
                                filter={filter}
                                hideResultCount={hideResultCount}
                                dataViewIndex={dataViewIndex}
                                extractorRefs={extractorRefs}
                                onFilterSelected={onAddFilter}
                            />
                        </div>
                    )}
                    {children ? (
                        <div className={theme.children}>{children}</div>
                    ) : null}
                </div>
                {filter !== null ? (
                    <div className={theme.filterContainer}>
                        <FilterTags
                            filter={filter}
                            onRemoveFilter={onRemoveFilter}
                            onResetFilter={onResetFilter}
                            getExtractor={(extractorId: string) =>
                                getExtractor(
                                    queryResult.dataView,
                                    extractorId
                                ) as DataExtractor<unknown, unknown>
                            }
                            toDisplayFilter={toDisplayFilter}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}

interface FilterProps<ITEM> {
    id: string;
    queryResult: QueryResult<ITEM>;
    dataViewIndex: DataViewIndex<ITEM>;
    hideTypeahead?: boolean;
    hideResultCount?: boolean;
    filter: SimpleAndFilter | null;
    children?: React.ReactNode;
    extractorRefs: Array<ExtractorRef>;
    onAddFilter: (
        extractorId: string,
        filter: SimpleFieldFilter,
        excluded: boolean
    ) => void;
    onRemoveFilter: (
        extractorId: string,
        filter: SimpleFieldFilter,
        excluded: boolean
    ) => void;
    onResetFilter: () => void;
}

class TableFilter<ITEM> extends React.PureComponent<TableFilterProps<ITEM>> {
    render = () => {
        const { hideTypeahead, filter, children } = this.props;
        const hideEverything = hideTypeahead && !children && filter === null;
        return hideEverything ? null : (
            <div className={theme.tableFilter}>
                <Filter<ITEM> {...this.props} />
            </div>
        );
    };
}

type TableFilterProps<ITEM> = FilterProps<ITEM>;

export {
    ExtractorRef,
    Filter,
    type FilterProps,
    TableFilter,
    type TableFilterProps,
};
